import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import cn from "../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CityState = _ref => {
  let {
    address,
    className
  } = _ref;
  const {
    city = {},
    state = {}
  } = address;
  const hasCity = !isEmpty(city);
  const hasState = !isEmpty(state);
  const cityStateClassName = cn('text-text-blue text-sm font-regular-font', className);
  if (hasCity && hasState) {
    return /*#__PURE__*/_jsxs("span", {
      className: cityStateClassName,
      children: [city, ", ", /*#__PURE__*/_jsx("abbr", {
        children: state
      })]
    });
  }
  if (hasCity) {
    return /*#__PURE__*/_jsx("span", {
      className: cityStateClassName,
      children: city
    });
  }
  if (hasState) {
    return /*#__PURE__*/_jsx("span", {
      className: cityStateClassName,
      children: state
    });
  }
  return null;
};
CityState.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string
  }).isRequired
};
export default CityState;
//# sourceMappingURL=CityState.js.map